export default "__VITE_ASSET__sI_pufhh__"